import type { ReactNode, MouseEventHandler } from "react";
import { createPortal } from "react-dom";
import { useI18n } from "../../i18n/useI18n";

export default function MyConfirmModal({
  title,
  message,
  onCancel,
  onConfirm,
  showCancel = true,
  confirmText = 'Подтвердить',
  confirmDisabled = false,
  cancelText = 'Отмена',
  overlayClassName = ""
}: { title?: ReactNode; message?: ReactNode; onCancel?: () => void; onConfirm?: MouseEventHandler<HTMLButtonElement>; showCancel?: boolean; confirmText?: ReactNode; confirmDisabled?: boolean; cancelText?: ReactNode; overlayClassName?: string }) {
  const { t } = useI18n();
  const renderTranslatable = (value: ReactNode, fallback = "") =>
    typeof value === "string" ? t(value || fallback) : value;

  const modal = (
    <div className={`modal-overlay${overlayClassName ? ` ${overlayClassName}` : ""}`}>
      <div className="base-dialog small-dialog confirm-dialog" role="alertdialog" aria-modal="true">
        <h4 className="base-dialog__header">
          {renderTranslatable(title, "Подтвердите действие")}{" "}
        </h4>
        <div className="base-dialog__content">
          <p>{renderTranslatable(message)}</p>
        </div>
        <div className={`confirm-dialog__actions${showCancel ? "" : " confirm-dialog__actions--single"}`}>
          {showCancel && (
            <button
              type="button"
              className="confirm-dialog-button confirm-dialog-button--cancel"
              onClick={onCancel}
            >
              {renderTranslatable(cancelText)}
            </button>
          )}
          <button
            type="button"
            onClick={onConfirm}
            className="confirm-dialog-button confirm-dialog-button--confirm"
            disabled={confirmDisabled}
            autoFocus
          >
            {renderTranslatable(confirmText)}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
